import { render, staticRenderFns } from "./atendimentos.vue?vue&type=template&id=71ef5b58&scoped=true"
import script from "./atendimentos.vue?vue&type=script&lang=js"
export * from "./atendimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ef5b58",
  null
  
)

export default component.exports